import * as actions from './actions'

const initState = {
    emailAn: '',
    emailCc: '',
    emailMessage: '',
    user: '',
    reportData: ''
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.MAIL_REQUEST:
            return {
                ...state,
                ...{
                    emailAn: action.emailAn,
                    emailCc: action.emailCc,
                    emailMessage: action.emailMessage,
                    user: action.user,
                    reportData: action.reportData
                }
            }
        default:
            return state
    }
}
